export interface SHMChannelData {
  time:           Date[];
  icorr:          number[];
  ecorr:          number[];
  /** ecorr's own time axis (identical to `time` until ecorr-specific handling is defined). */
  time_ecorr:     Date[];
  rs:             number[];
  rp:             number[];
  cdl:            number[];
  charge:         number[];
  thickLoss:      number[];
  method:         string[];
  saturated:      string[];
  saturationState: string[];
  tempNtc1:       (number | null)[];
  tempNtc2:       (number | null)[];
  tempPcb:        (number | null)[];
  scale:          string[];
  csvRef:         string[];
}

export type SHMChannelType = 'corrosion' | 'ph' | 'chlorides' | 'None';

export const SHM_CHANNEL_TYPE_VALUES: SHMChannelType[] = ['corrosion', 'ph', 'chlorides', 'None'];

export const SHM_CHANNEL_TYPES: { value: SHMChannelType; label: string }[] = [
  { value: 'None', label: 'measurement.shm.channelTypes.none' },
  { value: 'corrosion', label: 'measurement.shm.channelTypes.corrosion' },
  { value: 'ph', label: 'measurement.shm.channelTypes.ph' },
  { value: 'chlorides', label: 'measurement.shm.channelTypes.chlorides' },
];

/**
 * `ph` and `chlorides` are two distinct degradation methodologies — different
 * ingest/processing pipelines and data views, grouped here for the checks that
 * only need to know "is this a degradation channel" vs corrosion.
 */
export const SHM_DEGRADATION_CHANNEL_TYPES = ['ph', 'chlorides'] as const;

export const MAX_SHM_CHANNELS = 8;

export const SHM_VARIABLES = {
  corrosion: {
    icorr: { label: 'icorr', unit: 'uA/cm2' },
    ecorr: { label: 'ecorr', unit: 'mV' },
    thickLoss: { label: 'ThickLoss', unit: 'um' },
    charge: { label: 'Charge', unit: 'C ?' },
    rp: { label: 'rp', unit: 'Ohm' },
    rs: { label: 'rs', unit: 'Ohm' },
  },
  // TODO: define once the pH processing pipeline is specced.
  ph: {} as Record<string, { label: string; unit: string }>,
  // TODO: define once the chlorides processing pipeline is specced.
  chlorides: {} as Record<string, { label: string; unit: string }>,
};
